import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "eventCard news" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_news icon" }, null, -1)
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "when" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {
      name: 'Article',
      params: { id: _ctx.item.details.news_id },
    },
    class: "boxMessage noPad"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h2", null, _toDisplayString(_ctx.item.details.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.item.details.summary), 1)
        ]),
        (_ctx.item.details.image_url !== null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.item.details.image_url,
              alt: _ctx.$t('accessibility.news.image')
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$moment(_ctx.item.created_at).fromNow()), 1)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}